import EmployeeBox from '~/themes/base/components/content/EmployeeBox'

export default {
  extends: EmployeeBox,
}
